import { Box, Typography } from '@mui/material';
import { PageContentProcessTabs } from 'framework/ViewTypes/components';

const RecruitmentPoolTabs = () => {
  return (
    <PageContentProcessTabs
      tabs={[
        {
          id: 'health',
          name: 'Health',
          panel: (
            <Box p={2}>
              <Typography color="textSecondary">TODO: Health content.</Typography>
            </Box>
          ),
        },
        {
          id: 'timeline',
          name: 'Timeline',
          panel: (
            <Box p={2}>
              <Typography color="textSecondary">TODO: Timeline content.</Typography>
            </Box>
          ),
        },
        {
          id: 'pfrs',
          name: 'PFRs',
          panel: (
            <Box p={2}>
              <Typography color="textSecondary">TODO: PFRs content.</Typography>
            </Box>
          ),
        },
        {
          id: 'hiring-plan',
          name: 'Hiring plan',
          panel: (
            <Box p={2}>
              <Typography color="textSecondary">TODO: Hiring plan content.</Typography>
            </Box>
          ),
        },
        {
          id: 'applications',
          name: 'Applications',
          panel: (
            <Box p={2}>
              <Typography color="textSecondary">TODO: Applications content.</Typography>
            </Box>
          ),
        },
        {
          id: 'job-posting',
          name: 'Job posting',
          panel: (
            <Box p={2}>
              <Typography color="textSecondary">TODO: Job posting content.</Typography>
            </Box>
          ),
        },
      ]}
    />
  );
};

export default RecruitmentPoolTabs;
